module.exports = __webpack_public_path__ + "img/github.53011edb.png";